// extracted by mini-css-extract-plugin
export var cardContainer = "_oe-0";
export var cardHeader = "_oe-2";
export var collapsedState = "_oe-3";
export var dragHandle = "_oe-5";
export var dragHandleIcon = "_oe-6";
export var dragging = "_oe-1";
export var titleArea = "_oe-4";